var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-field"},[_c('iframe',{ref:_vm.fieldRef,attrs:{"src":_vm.url,"height":"600","width":"100%","title":"Open url"},on:{"load":_vm.iframeLoaded}})])
}
var staticRenderFns = []

export { render, staticRenderFns }